import { FC } from "react";
import { Box, Button, IconButton, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";
import { useIsAdmin } from "../../../auth/useIsAdmin";
import { useRoles } from "../../../auth/useRoles";
import { canBulkSyncWarehouse } from "../../../auth/permissions";

export const CounterpartyLookupMenu: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isAdmin = useIsAdmin();
  const roles = useRoles();

  const onSyncPage = location.pathname.includes("/sync");
  const canSync = canBulkSyncWarehouse(roles);

  // Compliance and Risk reach the sync page without holding a global role, so the menubar has to
  // render for them too, not only for Admin and Market Access.
  if (!isAdmin && !canSync) {
    return null;
  }

  return (
    <Box display="flex" width="100%" alignItems="center" gap={1}>
      <IconButton
        onClick={() => navigate(onSyncPage ? "/counterpartylookup" : "/home")}
        sx={{ color: "secondary.main" }}
      >
        <ArrowBackIcon />
      </IconButton>
      <Typography variant="h5">
        {onSyncPage
          ? "Counterparty lookup: warehouse sync"
          : "Counterparty lookup"}
      </Typography>

      <Box flex={1} />

      {canSync && !onSyncPage ? (
        <Button
          variant="outlined"
          onClick={() => navigate("/counterpartylookup/sync")}
        >
          Sync all with warehouse
        </Button>
      ) : null}
    </Box>
  );
};
